import { render, staticRenderFns } from "./VirtualAccountDetail.vue?vue&type=template&id=5b9d77c0&"
import script from "./VirtualAccountDetail.vue?vue&type=script&lang=js&"
export * from "./VirtualAccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./VirtualAccountDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports